module.exports = __webpack_public_path__ + "static/media/librarian_framed1.423222a0.png";